import { QueryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppDataContext } from '../../contexts/appData';

export const useGetProductAnalytics = ({ productId, periodId }) => {
  const { api } = useContext(AppDataContext);

  const { data, refetch, isLoading, isPending, isFetching } = useQuery({
    queryKey: [QueryKeys.ProductAnalytics, productId, periodId],
    queryFn: () => api.getProductAnalytics(productId, periodId),
    staleTime: 1000 * 60 * 60,
    placeholderData: (previousData) => previousData,
  });

  const current = data?.data;
  const difference = current?.difference;
  const currentTotal = current?.totals;
  const currentList = current?.data ?? [];

  return { current, difference, currentTotal, currentList, isLoading, refetch, isPending, isFetching };
};
